import React from 'react';
import { useParams } from 'react-router';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { loadTaskPpr } from './api';

export const path = '/ppr/task/:id';
export const getPath = (taskId: number) => `/ppr/task/${taskId}`;

const PageApplicationPpr: React.FC = (props) => {
  const { id } = useParams<{ id: string; areaId: string }>();

  const ApplicationPpr = Loadable.Map({
    loader: {
      page: () => import('./page'),
      task: () => loadTaskPpr(+id),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <ApplicationPpr {...props} />;
};

export default PageApplicationPpr;
